import { useState, useMemo } from 'react';
import { useIntl } from 'react-intl';

export const useOrder = (ORDER, initialOrder = ORDER[0]) => {
  const intl = useIntl();

  const translatedOrder = useMemo(() => {
    return ORDER.map((o) => ({
      ...o,
      label: intl.formatMessage({ id: `sort.${o.label}` }),
    }));
  }, [intl.locale]);

  const translatedInitialOrder = useMemo(() => {
    return translatedOrder.find(o => o.value === initialOrder.value) || translatedOrder[0];
  }, [translatedOrder, initialOrder.value]);

  const [order, setOrderValue] = useState(translatedInitialOrder);
  const [orderTouched, setOrderTouched] = useState(false);

  const setOrder = (o) => {
    setOrderTouched(true);
    setOrderValue(o);
  };

  return [translatedOrder, order, setOrder, orderTouched];
};
